import React from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { classNames } from '../../helpers/classNames';
import { BUN_PREVIEW } from '../../bunPreview';

/**
 * RouteLoadingSpinner Component - Full-screen route loading indicator
 *
 * Displays a full-screen centered loading spinner with text.
 * Used when loading entire route/page content during navigation.
 *
 * Features:
 * - Full screen height and width (h-screen w-full)
 * - Centered flex container
 * - Spinning icon from react-icons (AiOutlineLoading3Quarters)
 * - "Loading..." text below spinner
 * - Bun theme colors in preview; white and gray in legacy mode
 *
 * @component
 * @returns {JSX.Element} Full-screen loading spinner
 *
 * @remarks
 * - Occupies entire viewport with h-screen
 * - Uses the active Bun canvas or legacy white background
 * - Icon size: 48px (h-12 w-12)
 * - Text and spinner colors follow the active theme
 * - No props - fixed appearance for full-page loading
 * - Typically used in route loading suspense boundaries
 *
 * @example
 * <Suspense fallback={<RouteLoadingSpinner />}>
 *   <LazyComponent />
 * </Suspense>
 */
const RouteLoadingSpinner = () => {
    return (
        <div className={classNames('flex h-screen w-full items-center justify-center', BUN_PREVIEW ? 'bun' : 'bg-white')}>
            <div className="flex flex-col items-center space-y-4">
                <AiOutlineLoading3Quarters className={classNames('h-12 w-12 animate-spin', BUN_PREVIEW ? 'text-bun-stone' : 'text-gray-300')} />
                <span className={classNames('font-medium', BUN_PREVIEW ? 'text-bun-muted' : 'text-gray-600')}>Loading...</span>
            </div>
        </div>
    );
};

export default RouteLoadingSpinner;
